import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchRevenueAgency, IRevenueAgency } from '../types'

export const listRevenueAgency = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null
): Promise<IFetchItems<IRevenueAgency>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'revenue/agency'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal
	}
	const data = await lib.fetching<IFetchItems<IFetchRevenueAgency>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchRevenueAgency): IRevenueAgency => {
			const { createdAt, updatedAt, ...row } = item
			return {
				...row,
				percents: row.percents?.map(item => ({
					...item,
					at: dt(item.at).toDate(),
					nextAt: item.nextAt ? dt(item.nextAt).toDate() : null
				})) ?? [],
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate()
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0
	}
}
